import {atomBadgeDesigns, atomBadgeSizes} from '@s-ui/react-atom-badge'

const TYPES = {
  CHECKED: 'CHECKED',
  DEFAULT: 'DEFAULT',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS'
}

const commonBadgeProps = {design: atomBadgeDesigns.SOFT, size: atomBadgeSizes.LARGE}

const BADGE_TYPE_PROPS = {
  [TYPES.CHECKED]: {
    ...commonBadgeProps,
    type: 'prosLight'
  },
  [TYPES.DEFAULT]: {
    ...commonBadgeProps,
    type: 'gray'
  },
  [TYPES.ERROR]: {
    ...commonBadgeProps,
    type: 'error'
  },
  [TYPES.SUCCESS]: {
    ...commonBadgeProps,
    type: 'prosLight'
  }
}

export {BADGE_TYPE_PROPS, TYPES}
